/* LAFS MOTION LAYER (theme v101, Nov 2026). Loaded deferred from layout/theme.liquid on every page; styles in snippets/lafs-motion-css.
   1. Reveals .ra elements (printed by the Start Here sections with --d stagger delays; the hero also has a pure-CSS
      entrance in lafs-motion-css so the first screen never waits for this script) and, on every other page,
      the sections and photos that sit below the first screen at load (tagged here as .m-sec / .m-img, so nothing
      that is already visible ever blinks).
   2. Start Here extras: hero entrance, scroll hint, hero parallax, program-photo drift, avatar roll, count-ups,
      ticking countdown digits, "Show all reviews", "Read more".
   3. A 3 px progress line on every page.
   Off entirely for prefers-reduced-motion and inside the theme editor (the layout then never sets html.js, so every
   element is simply visible). */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (RM) return;
  var H = document.documentElement; if (!H.classList.contains('js')) H.classList.add('js');
  function $(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var vh = window.innerHeight || 800;

  /* ---- generic pages: tag what is below the first screen ---- */
  var SKIP = '[class*="slider"],[class*="carousel"],[class*="swiper"],[class*="marquee"],[class*="scrolling"],.efbf,.shbk-natives,[data-cowlendar-inline],.cowlendar-modal';
  $('main .shopify-section').forEach(function (sec) {
    if (sec.querySelector('.sh2') || sec.querySelector('.efbf') || sec.hasAttribute('data-motion')) return;
    var r = sec.getBoundingClientRect();
    if (r.height < 40) return;
    if (r.top < vh * 0.9) return;                                   /* on screen at load: leave it exactly as painted */
    sec.classList.add('m-sec');
    var n = 0;
    $('img', sec).forEach(function (img) {
      if (img.closest(SKIP)) return;
      var b = img.getBoundingClientRect(); if (b.width < 120 || b.height < 80) return;
      var cs = getComputedStyle(img); if (cs.position === 'fixed' || cs.position === 'sticky') return;
      img.classList.add('m-img'); img.style.setProperty('--d', (160 + (n++ % 4) * 110) + 'ms');
    });
  });

  /* ---- reveal on scroll ---- */
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  var hero = document.querySelector('.sh2 .hero-e');
  requestAnimationFrame(function () { requestAnimationFrame(function () {   /* let the hidden state paint once so the first reveals animate too */
    $('.ra, .m-sec, .m-img, .sh2 h1, .sh2 h2, .sh2 h3').forEach(function (el) { io.observe(el); });
    if (hero) hero.classList.add('on');
  }); });
  setTimeout(function () { $('.ra:not(.on), .m-sec:not(.on), .m-img:not(.on), .sh2 h1:not(.on), .sh2 h2:not(.on), .sh2 h3:not(.on)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) el.classList.add('on'); }); }, 2500);
  setTimeout(function () { $('.ra:not(.on), .m-sec:not(.on), .m-img:not(.on), .sh2 h2:not(.on), .sh2 h3:not(.on)').forEach(function (el) { el.classList.add('on'); }); }, 12000);   /* nothing stays hidden, whatever happens */

  /* ---- scroll effects ---- */
  var line = document.createElement('div'); line.className = 'lafs-progress'; document.body.appendChild(line);
  if (hero) { var hint = document.createElement('div'); hint.className = 'lafs-hint'; hint.innerHTML = '<span>Scroll</span><i></i>'; hero.appendChild(hint); }
  var bg = hero && hero.querySelector('[data-parallax]'), photos = $('.sh2 .prog .ph img'), ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset, h = H.scrollHeight - window.innerHeight;
      line.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
      if (y > 40) H.classList.add('scrolled'); else H.classList.remove('scrolled');
      if (bg) bg.style.transform = 'translate3d(0,' + Math.min(y * 0.28, 320) + 'px,0)';
      for (var i = 0; i < photos.length; i++) { var img = photos[i], r = img.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) continue; var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight; img.style.setProperty('--py', (p * -26).toFixed(1) + 'px'); }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---- count-ups ---- */
  function countUp(el) {
    var raw = el.getAttribute('data-count'), to = parseFloat(raw), dec = (raw.split('.')[1] || '').length, suf = el.getAttribute('data-suffix') || '', dur = 1100, t0 = null;
    if (isNaN(to)) return;
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); p = 1 - Math.pow(1 - p, 3); el.textContent = (to * p).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } }); }, { threshold: 0.4 });
  $('[data-count]').forEach(function (el) { cio.observe(el); });

  /* ---- ticking digits (Price Hub countdown, efp-state.liquid writes the text every second) ---- */
  $('[data-efp-countdown]').forEach(function (el) { var last = el.textContent; new MutationObserver(function () { if (el.textContent === last) return; last = el.textContent; el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); }).observe(el, { characterData: true, childList: true, subtree: true }); });

  /* ---- avatar roll: faces cycle through every reviewer (pool printed by the section as JSON) ---- */
  $('.sh2 .roll').forEach(function (roll) {
    var faces = roll.querySelector('.roll-faces'), scope = roll.closest('.sh2') || document;
    var poolEl = scope.querySelector('[data-sh2-avatars]') || document.querySelector('[data-sh2-avatars]'), pool = [], i = 4, timer;
    try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
    if (!faces || pool.length < 6) return;
    $('.roll-faces > *', roll).forEach(function (f, k) { f.style.setProperty('--i', k); });
    function tick() {
      if (document.hidden) return;
      var old = faces.firstElementChild; if (!old) return;
      i = (i + 1) % pool.length;
      var n = document.createElement('img'); n.src = pool[i]; n.alt = ''; n.width = 44; n.height = 44; n.decoding = 'async'; n.classList.add('in');
      old.style.transform = 'translateX(-10px) scale(.6)'; old.style.opacity = '0';
      setTimeout(function () { old.remove(); }, 420);
      faces.appendChild(n);
    }
    timer = setInterval(tick, 2400);
    roll.addEventListener('mouseenter', function () { clearInterval(timer); });
    roll.addEventListener('mouseleave', function () { timer = setInterval(tick, 2400); });
  });

  /* ---- reviews: show all, read more ---- */
  $('.sh2 [data-show-all]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = btn.closest('.sh2').querySelector('.rvs'); if (!grid) return;
      grid.classList.add('open');
      $('.rv.more', grid).forEach(function (c, k) { c.style.setProperty('--d', ((k % 3) * 110 + 40) + 'ms'); io.observe(c); });
      btn.hidden = true;
    });
  });
  $('.sh2 [data-rd]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.rv'), open = card.classList.toggle('open');
      btn.textContent = open ? 'Show Less' : 'Read More'; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- Black Friday: "Reserve My Spot" opens the layer's pop-up when it is on the page ---- */
  $('[data-bf-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { var p = document.querySelector('.efbf-pill'); if (p) { e.preventDefault(); p.click(); } });
  });

})();
